import { render, staticRenderFns } from "./OwnChallengesTab.vue?vue&type=template&id=77e462b8&scoped=true&"
import script from "./OwnChallengesTab.vue?vue&type=script&lang=js&"
export * from "./OwnChallengesTab.vue?vue&type=script&lang=js&"
import style0 from "./OwnChallengesTab.vue?vue&type=style&index=0&id=77e462b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e462b8",
  null
  
)

export default component.exports